import { useState, useEffect } from "react";

export default function AvailableSeasonRange(props) {
  const { availableSeason } = props;

  const months = [
    {
      long: "JANUARI",
      short: "Jan",
      order: 0,
    },
    {
      long: "FEBRUARI",
      short: "Feb",
      order: 1,
    },
    {
      long: "MAART",
      short: "Mar",
      order: 2,
    },
    {
      long: "APRIL",
      short: "Apr",
      order: 3,
    },
    {
      long: "MEI",
      short: "Mei",
      order: 4,
    },
    {
      long: "JUNI",
      short: "Jun",
      order: 5,
    },
    {
      long: "JULI",
      short: "Jul",
      order: 6,
    },
    {
      long: "AUGUSTUS",
      short: "Aug",
      order: 7,
    },
    {
      long: "SEPTEMBER",
      short: "Sep",
      order: 8,
    },
    {
      long: "OKTOBER",
      short: "Okt",
      order: 9,
    },
    {
      long: "NOVEMBER",
      short: "Nov",
      order: 10,
    },
    {
      long: "DECEMBER",
      short: "Dec",
      order: 11,
    },
  ];

  const [monthFrom, setMonthFrom] = useState(
    months.find((a) => a.long === availableSeason.month_from)
  );
  const [monthTill, setMonthTill] = useState(
    months.find((a) => a.long === availableSeason.month_till)
  );

  function getLeftOffset(element) {
    let offset = element?.offsetLeft;
    return offset;
  }
  function getRightOffset(element) {
    let offset = element?.offsetLeft + element?.offsetWidth;
    return offset;
  }

  const [leftOffset, setLeftOffset] = useState();
  const [rightOffset, setRightOffset] = useState();

  const [firstBarWidth, setFirstBarWidth] = useState();
  const [secondBarWidth, setSecondBarWidth] = useState();

  const calculateSeasonRange = () => {
    let container = document.getElementById("offsetContainer");
    let leftElement = document.getElementById(
      `singleMonthLine-${monthFrom?.order}`
    );
    let rightElement = document.getElementById(
      `singleMonthLine-${monthTill?.order}`
    );
    let leftOffset = getLeftOffset(leftElement);
    let rightOffset = getRightOffset(rightElement);

    let containerLeftOffset = getLeftOffset(container);
    let containerRightOffset = getRightOffset(container);

    setLeftOffset(leftOffset);
    setRightOffset(rightOffset);
    if (rightOffset < leftOffset) {
      setFirstBarWidth(containerRightOffset - leftOffset - containerLeftOffset);
      setSecondBarWidth(rightOffset);
      return;
    }
    setFirstBarWidth(rightOffset - leftOffset);
  };

  useEffect(() => {
    setTimeout(() => {
      calculateSeasonRange();
    }, 200);
  }, [monthFrom, monthTill]);

  return (
    <section className="mt-8">
      <h3 className="mt-4 font-bold lg:text-xl">Beschikbare periode</h3>
      <div className="mt-8">
        <div className="relative" id="offsetContainer">
          <div className="absolute top-2.5 left-0 transform -translate-y-1/2 w-full h-1 bg- rounded-full"></div>
          {rightOffset < leftOffset ? (
            <>
              <div
                className="absolute top-2.5 left-0 transform -translate-y-1/2 h-6 bg-orange-300 rounded-[5px] overflow-hidden"
                style={{
                  left: `${leftOffset}px`,
                  width: `${firstBarWidth}px`,
                }}
              >
                <span className="hidden sm:block absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 text-xs md:text-sm text-white uppercase font-bold">
                  Beschikbaar
                </span>
              </div>
              <div
                className="absolute top-2.5 left-0 transform -translate-y-1/2 h-6 bg-orange-300 rounded-[5px] overflow-hidden"
                style={{
                  left: `${0}px`,
                  width: `${secondBarWidth}px`,
                }}
              >
                <span className="hidden sm:block  absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 text-xs md:text-sm text-white uppercase font-bold">
                  Beschikbaar
                </span>
              </div>
            </>
          ) : (
            <div
              className="absolute top-2.5 left-0 transform -translate-y-1/2 h-6 bg-orange-300 rounded-[5px] overflow-hidden"
              style={{
                left: `${leftOffset}px`,
                width: `${firstBarWidth}px`,
              }}
            >
              <span className="hidden sm:block absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 text-xs md:text-sm text-white uppercase font-bold">
                Beschikbaar
              </span>
            </div>
          )}
          <div className="flex justify-between">
            {months.map((a) => (
              <div key={a.long} className="flex flex-col items-center">
                <div
                  className="w-1 h-5 rounded-full bg-olaf-green-700"
                  id={`singleMonthLine-${a.order}`}
                ></div>
                <span className="mt-4 hidden md:block">{a.short}</span>
                <span className="mt-4 md:hidden">{a.order + 1}</span>
              </div>
            ))}
          </div>
          <span className="mt-2 block md:hidden">* Periode in maanden</span>
        </div>
      </div>
    </section>
  );
}
